<div #modalContainer [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-1/2 max-h-full rounded-lg bg-primary-purple-light-2">
        <button (click)="onClose()" type="button" class="absolute top-4 right-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
            <img [src]="images.close" alt="close" class="h-6 w-6" />
        </button>
        <div class="flex">
            <div class="w-1/2 p-8">
                <h1 class="font-bold text-[18px] text-primary-purple mb-4">{{ literalService.get('users.documents.modal.uploadedDocuments', true)}}</h1>
                @if (getDocumentTypes().length === 0) {
                    <div class="flex flex-col justify-between items-center w-48 h-48 px-6 mt-6">
                        <img [src]="images.noDocuments" alt="noDocuments" class="h-32 w-32"/>
                        <label class=" text-center text-[16px] text-neutrals-grey-04">
                            {{ literalService.get('users.documents.modal.noDocuments', true)}}
                        </label>
                    </div>
                }
                @for (docType of getDocumentTypes(); track $index) {
                    <div>
                        <h4 class="text-black font-semibold my-2">{{ literalService.get('users.documents.'+docType, true)}}</h4>
                        <ul>
                            @for (doc of documents[docType]; track $index) {
                                <li class="mb-2">
                                    <app-document-tag [document]="doc" (delete)="this.deleteAction.emit($event)" (download)="this.downloadDocument.emit($event)"/>
                                </li>
                            }
                        </ul>
                    </div>    
                }
            </div>
            <div class="w-1/2 p-8">
                <h1 class="font-bold text-[18px] text-primary-purple">{{ literalService.get('users.documents.modal.addDocuments', true)}}</h1>
                <h4 class="text-black font-semibold my-2">{{ literalService.get('users.documents.modal.firstStep', true)}}</h4>
                <app-select [elements]="getAllDocumentTypes()" [id]="getAllDocumentTypes()[0].id" (change)="changeType($event.target)"/>
                <h4 class="text-black font-semibold my-2">{{ literalService.get('users.documents.modal.secondStep', true)}}</h4>
                <div>
                    <input type="file" #fileInput multiple accept=".png, .jpg, .jpeg, .pdf" (change)="onSelectFile($event)" hidden />
                  </div>
                <div class="dashed-border mb-3 bg-white cursor-pointer" (click)="fileInput.click()">
                    <img [src]="images.document" alt="editUser" class="h-9 w-9 mb-3" />
                    <label class="upload-button-text font-semibold text-base cursor-pointer">{{ literalService.get('users.documents.modal.uploadFiles', true)}}</label>                
                </div>
                <div class="flex flex-wrap mb-2">
                    @for (documentCreate of documentCreateRequests; track $index) {
                        <app-document-tag [document]="documentCreate" (delete)="deleteDocumentCreateRequest($event)" (download)="downloadDocument.emit($event)"/>
                    }                
                </div>
                <div class="flex justify-between">
                    <input type="button" class="secondary gap-4 border-2 text-primary-purple font-semibold h-14 w-32 uppercase cursor-pointer" [value]="literalService.get('cancel', true)" (click)="onClose()" />
                    <button type="submit" class="primary gap-4 border-2 text-white font-semibold h-14 w-32 uppercase cursor-pointer" (click)="onUpload()" [disabled]="documentCreateRequests.length === 0 || isUploading">
                        @if (isUploading) {
                            <ng-lottie [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
                        }
                        @else {
                            {{ literalService.get('add', true) }}
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>